import Button from '@/components/Buttons/Button';
import { logger } from '@/services/logger';
import styled from '@emotion/styled';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useState } from 'react';

const CopyButton = styled(Button)<{ hidden: boolean }>`
    width: 100%;
    font-size: 16px;
    display: ${({ hidden }) => (hidden ? 'none' : 'block')};
`;

export default function CopyToClipboard({ text, hidden }: { text: string; hidden: boolean }) {
    const [copied, setCopied] = useState(false);

    const copyToClipboard = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
        } catch (err) {
            logger.error('Failed to copy text: ', err);
        }
    };

    return (
        <CopyButton data-testid="api-key-copy-button" color="secondary" onClick={() => copyToClipboard(text)} hidden={hidden}>
            <FileCopyIcon fontSize="small" style={{ marginRight: '5px' }} />
            {copied ? 'Copied!' : 'Copy to clipboard'}
        </CopyButton>
    );
}
